import { resolveElementTarget } from "./element-target.js";
import { useLayoutEffect, useRef } from "react";
//#region src/hooks/use-resize-observer.ts
/**
* Observe an element's size, invoking `onResize` once when observation starts and again on
* every size change. The latest `onResize` is always invoked, so inline callbacks are fine
* at call sites.
*
* Accepts a ref or the element itself, for consumers holding late-mounting elements in state.
*/
const useResizeObserver = (target, onResize, { enabled = true } = {}) => {
	const onResizeRef = useRef(onResize);
	useLayoutEffect(() => {
		onResizeRef.current = onResize;
	});
	useLayoutEffect(() => {
		const element = resolveElementTarget(target);
		if (!enabled || !element) return;
		onResizeRef.current(element);
		const observer = new ResizeObserver(() => onResizeRef.current(element));
		observer.observe(element);
		return () => observer.disconnect();
	}, [target, enabled]);
};
//#endregion
export { useResizeObserver };

//# sourceMappingURL=use-resize-observer.js.map